import { DependentFeaturesByKey } from '@common/common.constant';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
export class AuthService {
    constructor(router) {
        this.router = router;
    }
    static isLoggedIn() {
        return !!sessionStorage.getItem('session-token');
    }
    static getToken() {
        return sessionStorage.getItem('session-token');
    }
    static userInfo() {
        const userInfo = JSON.parse(sessionStorage.getItem('user-info'));
        return userInfo;
    }
    static userFeatures() {
        const userInfo = this.userInfo();
        const features = userInfo.feature;
        const featureMap = {};
        if (features && features.length > 0) {
            for (const f of features) {
                const fname = f.feature.featurename;
                featureMap[fname] = fname;
            }
        }
        return featureMap;
    }
    login(userInfo) {
        sessionStorage.setItem('session-token', userInfo.sessionToken);
        sessionStorage.setItem('user-info', JSON.stringify(userInfo));
        this.router.navigate(['/home']);
    }
    logout() {
        sessionStorage.removeItem('session-token');
        this.router.navigate(['/']);
    }
    static isAccess(feature) {
        const features = AuthService.userFeatures();
        const keys = Object.keys(features) || [];
        let isAccess = !!features[feature];
        if (keys.length === 0) {
            return true;
        }
        if (DependentFeaturesByKey[feature]) {
            const _features = Object.getOwnPropertyNames(DependentFeaturesByKey[feature]);
            for (const f of _features) {
                if (!!features[f]) {
                    isAccess = true;
                    break;
                }
            }
        }
        return isAccess;
    }
}
AuthService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthService_Factory() { return new AuthService(i0.ɵɵinject(i1.Router)); }, token: AuthService, providedIn: "root" });
